import { useSelector } from "react-redux"
import { getAllFormatSizes, getAllPaperSizes } from "@store/reducers/paper/selectors"
import { getUnitType } from "@store/reducers/paper/selectors"

import { PageSize } from "@store/reducers/init/types"
import { convertToUnit } from "@utils/data"

function _getSize(size: PageSize, sizes, unitType) {
  if (size.isCustom) {
    return size
  }

  // try finding by name;
  if (size.name && sizes[size.name]) {
    return sizes[size.name]
  }

  // try finding by width and height;
  let matchingSize = Object.values(sizes as PageSize[]).find((s) => s.width === size.width && s.height === size.height)

  if (matchingSize) {
    return matchingSize
  } else {
    //create new custom size.
    size.isCustom = true

    size.name = `${convertToUnit(size.width, unitType)} x ${convertToUnit(size.height, unitType)}`
    return size
  }
}

export function getSize(size: PageSize, sizes, unitType) {
  let _size = _getSize(size, sizes, unitType)
    return { ..._size }
  }

export default function useSizes() {
  const pageSizes = useSelector(getAllPaperSizes)
  const formatSizes = useSelector(getAllFormatSizes)
  const unitType = useSelector(getUnitType)

  function getFormatSize(size: PageSize) {
    return getSize(size, formatSizes, unitType)
  }

  function getPageSize(size: PageSize) {
    return getSize(size, pageSizes, unitType)
  }

  return { getFormatSize, getPageSize }
}
